import ReactOnRails from 'react-on-rails';
import '../private/stylesheets/index.scss';

import Affiliate from '../private/components/AffiliateThreeSixty/Affiliate';
import Navbar from '../shared/components/Navbar';
import AffiliateList from '../private/components/AffiliateThreeSixty/AffiliateList';
import Billing from '../private/components/Billing';
import Invoice from '../private/components/Billing/Invoice';
import Plans from '../private/components/Billing/Plans';
import BillingTransactionList from '../private/components/Billing/TransactionList';
import Transaction from '../private/components/Billing/Transaction';
import Dashboard from '../private/components/Dashboard';
import Settings from '../private/components/Settings';
import Support from '../private/components/Support';
import Workspace from '../private/components/Workspace';
import UserIndex from '../private/components/User';
import TeamIndex from '../private/components/Team';
import NewsDetails from '../private/components/Dashboard/NewsDetails';
import SideNav from '../shared/components/Sidebar/SideNav';
import Alert from '../shared/components/Alert/Alert';
import SignUpConfigurator from '../shared/components/SignUp/SignUpConfigurator';
import SignUpConfirmation from '../shared/components/SignUp/SignUpConfirmation';
import SignUpOrganization from '../shared/components/SignUp/SignUpOrganization';
import SubscriptionUpgrade from '../private/components/Billing/Subcription/SubscriptionUpgrade';
import SubscriptionDowngrade from '../private/components/Billing/Subcription/SubscriptionDowngrade';
import SubscriptionErrorModal from '../private/components/Billing/Subcription/SubscriptionErrorModal';

window.process = require('process')

ReactOnRails.register({
  Affiliate,
  AffiliateList,
  Billing,
  'Billing::Invoice': Invoice,
  'Billing::Plans': Plans,
  'Billing::TransactionList': BillingTransactionList,
  'Billing::Transaction': Transaction,
  Dashboard,
  'Dashboard::NewsDetails': NewsDetails,
  Settings,
  'Subscription::Upgrade': SubscriptionUpgrade,
  'Subscription::Downgrade': SubscriptionDowngrade,
  'Subscription::ErrorModal': SubscriptionErrorModal,
  Support,
  Workspace,
  UserIndex,
  TeamIndex,
  Navbar,
});

// Shared files
ReactOnRails.register({
  SideNav,
  Alert,
  SignUpConfigurator,
  SignUpConfirmation,
  SignUpOrganization,
});
